import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'

const UPLOAD_IMAGE = gql`
  mutation uploadUserPhoto($input: UploadPhotoInput) {
  uploadUserPhoto(input: $input) {
    name
    extension
  }
}
`

export default () => useMutation(UPLOAD_IMAGE)
